/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from 'react';
import resume from "../Resume/Suraj-Kamat-Resume.pdf"
export default function Navbar() {
  // // Dark Mode / light mode
  // let darkmode = document.querySelector("#darkmode");

  // darkmode.onclick = () => {
  //   if (darkmode.classList.contains("bx-moon")) {
  //     darkmode.classList.replace("bx-moon", "bx-sun");
  //     document.body.classList.add("active");
  //   } else {
  //     darkmode.classList.replace("bx-sun", "bx-moon");
  //     document.body.classList.remove("active");
  //   }
  // };

  const handleResume = () => {
    window.open("https://drive.google.com/file/d/1fCow8sfk-xgyl8HhRI0tXiwCVz3AAeMO/view?usp=sharing",
      "_blank")
  }

  const [active, setActive] = useState(false)
  return (
    <header>
      <a href="#" className="logo">Suraj<span>Kamat</span></a>

      <div className="bx bx-menu" id="menu-icon" onClick={() => setActive(!active)}></div>

      <ul className={active ? "navbar active" : "navbar"} id="nav-menu">
        <li><a className="nav-link home" href="#home">Home</a></li>
        <li><a className="nav-link about" href="#about">About</a></li>
        <li><a className="nav-link skills" href="#skills">Skills</a></li>
        <li><a className="nav-link projects" href="#projects">Projects</a></li>
        <li><a className="nav-link contact" href="#contact">Contact</a></li>
        {/* <!-- <li>
          <button id="resume-button-1"><a href="./Resume/Alok_Bal_Resume.pdf" className="nav-link resume" id="resume-button-1">Resume</a></button>
        </li> --> */}
        <li className="nav-link resume"><a
          onClick={handleResume}
          id="resume-link-1" href={resume} target="_blank"
          download="Suraj_Kamat_Resume"> <button className="resume-button" id="resume-button-1">Resume</button> </a>
        </li>
        {/* <div className="bx bx-moon" id="darkmode"></div> */}
      </ul>
    </header>
  )
}



